<template>
  <div v-if="$route.name === 'Error' || $route.name === 'Success'" class="flex min-h-screen flex-col justify-center">
    <div class="flex w-full justify-center">
      <img src="https://www.myoutdesk.com/wp-content/uploads/2025/01/cropped-MyOutDesk-Official-Logo-1536x172.png" class="mb-6 p-2 max-w-2xl" alt="MyOutDesk Logo" />
    </div>
    <router-view />
  </div>
  <div v-else>
    <div class="" :class="[!fullPageView ? 'container mx-auto p-6 max-w-7xl' : 'container mx-auto p-3 md:p-6']">
      <img v-if="!fullPageView" src="https://www.myoutdesk.com/wp-content/uploads/2025/01/cropped-MyOutDesk-Official-Logo-1536x172.png" class="mx-auto w-full max-w-xl md:h-16 md:w-auto" alt="MyOutDesk Logo" />
      <router-view @full-page-view="toggleFullPageView" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  const fullPageView = ref(false);
  const toggleFullPageView = (flag: boolean) => {
    fullPageView.value = flag;
  };
</script>
